import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  required,
  minLength,
} from 'react-admin';
import { Grid, Typography, Box } from '@mui/material';

export const RolesCreate: React.FC = () => (
  <Create title='Crear Nuevo Rol' redirect='show'>
    <SimpleForm>
      <Box sx={{ width: '100%', maxWidth: 600 }}>
        <Typography variant='h6' gutterBottom>
          Información del Rol
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextInput
              source='name'
              label='Nombre del Rol'
              validate={[required(), minLength(2)]}
              fullWidth
              helperText='Ej: Administrador, Usuario, Supervisor'
            />
          </Grid>
        </Grid>

        <Typography variant='body2' color='textSecondary' sx={{ mt: 2 }}>
          * Después de crear el rol, podrás configurar sus permisos específicos.
        </Typography>
      </Box>
    </SimpleForm>
  </Create>
);
